import { useSearchParams } from 'react-router-dom';

interface UseQueryControlOptions<T extends string> {
	allowedValues?: T[];
	defaultValue?: T;
}

export const useQueryControl = <T extends string = string>(param: string, { allowedValues, defaultValue }: UseQueryControlOptions<T> = {}) => {
	const [search, setSearch] = useSearchParams();

	let query = (search.get(param) || defaultValue || '') as T;

	if (allowedValues && !allowedValues.includes(query)) {
		query = defaultValue as T;
	}

	const onChange = (value: T) => {
		if (!value && typeof value !== 'number') {
			search.delete(param);
		} else {
			search.set(param, value);
		}
		setSearch(search);
	};

	return {
		query,
		onChange,
	};
};
